import validate from "/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/var/www/setlpn.ru/releases/20250530105812__branch--master__commit--5d167320/frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}